import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function getToken() {
  return localStorage.getItem("dl_token");
}
export function setToken(t) {
  if (t) localStorage.setItem("dl_token", t);
  else localStorage.removeItem("dl_token");
}

// Attach bearer token (resilient to browsers that drop partitioned cookies).
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function assetUrl(assetId) {
  const t = getToken();
  return `${API}/assets/${assetId}/download${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
